import { jsx as _jsx } from "react/jsx-runtime";
import '@styles/webdesktop/stylesheets/sideToggle.scss';
import { OperationType } from '@shared/utils/Trading/OperationType';
import { useLocalize } from '../../../hooks/useLocalize';
import { Typography } from '../../Typography/Typography';
import { BaseToggle } from '../BaseToggle/BaseToggle';
export const SideToggle = ({ side, isReverseOrder, onSideChange, disabled = false }) => {
    const [sellText, buyText] = useLocalize('general.trading.Sell', 'general.trading.Buy');
    return (_jsx(BaseToggle, { className: `side-toggle ${side === OperationType.Buy ? 'side-buy-active' : 'side-sell-active'}`, direction: isReverseOrder ? 'row-reverse' : 'row', value: side, onValueChange: onSideChange, disabled: disabled, showSeparator: false, options: [
            {
                value: OperationType.Buy,
                className: 'side-toggle-buy',
                content: _jsx(Typography, { children: buyText })
            },
            {
                value: OperationType.Sell,
                className: 'side-toggle-sell',
                content: _jsx(Typography, { children: sellText })
            }
        ] }));
};
